import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

export type ConflictingClass = {
  id: string;
  is1on1: boolean;
  startedAtUtc: string;
  endedAtUtc: string;
  participants: Array<{ id: string; givenName: string; familyName: string }>;
};

export type CheckedSlot = {
  startDateUtc: string;
  endDateUtc: string;
  teacherConflictingClass?: ConflictingClass | null;
  userConflictingClass?: ConflictingClass | null;
};

type CheckConflictsResponse = {
  check1on1PlanSlotConflicts: CheckedSlot[];
};

const Check1on1PlanSlotConflictsQuery = gql`
  query check1on1PlanSlotConflicts(
    $planId: String!
    $teacherId: String!
    $slots: [AddLessonTo1on1PlanSlotInput!]!
  ) {
    check1on1PlanSlotConflicts(
      planId: $planId
      teacherId: $teacherId
      slots: $slots
    ) {
      startDateUtc
      endDateUtc
      teacherConflictingClass {
        id
        is1on1
        startedAtUtc
        endedAtUtc
        participants {
          id
          givenName
          familyName
        }
      }
      userConflictingClass {
        id
        is1on1
        startedAtUtc
        endedAtUtc
        participants {
          id
          givenName
          familyName
        }
      }
    }
  }
`;

export function useCheck1on1PlanSlotConflicts() {
  const [execute, { loading }] = useLazyQuery<CheckConflictsResponse>(
    Check1on1PlanSlotConflictsQuery,
    { fetchPolicy: "no-cache" },
  );

  const checkConflicts = useCallback(
    async (params: {
      planId: string;
      teacherId: string;
      slots: Array<{ startUtc: string; endUtc: string }>;
    }): Promise<CheckedSlot[]> => {
      const result = await execute({ variables: params });
      return result.data?.check1on1PlanSlotConflicts ?? [];
    },
    [execute],
  );

  return { checkConflicts, loading };
}
